import moment from 'moment';

export const filterByDate = (filter, row) => {
  const date = row[filter.id];
  const formattedDate = moment(date).format('MM/DD/YYYY');

  const filterValue = filter.value.trim();
  if (!filterValue) return true;

  return formattedDate.includes(filterValue);
};
